import { useOnboardingProgress } from "@aurem/components";
import ROUTES from "const/routes";
import { useInitUserQuery } from "graphql/user";
import { AdminLayout } from "layouts/admin/AdminLayout";
import { useEnvironmentConfig } from "pages/Controls/hooks/environment.hooks";
import { useMemo } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { ProgressPageName } from "types";

export const AdminEntry = () => {
  const { isPageCompleted, loading: onboardingLoading } =
    useOnboardingProgress();
  const { config, loading: configLoading } = useEnvironmentConfig();
  const { data: userData, loading: userLoading } = useInitUserQuery();
  const { state, pathname } = useLocation();
  const { language } = useParams<{ language: string }>();
  const from = state?.from;

  const isPlatformRole = useMemo(() => {
    if (!userData?.user?.userRoles) return false;
    return userData.user.userRoles.some((userRole) => userRole.role.isPlatform);
  }, [userData]);

  const disclaimersCompleted = isPageCompleted(ProgressPageName.Disclaimers);
  const requiresPlatformSetup = isPlatformRole && Boolean(config?.firstLogin);

  if (onboardingLoading || userLoading || configLoading) {
    return null;
  }

  if (!disclaimersCompleted) {
    const isAtDisclaimers = pathname.includes(ROUTES.DISCLAIMERS);
    if (!isAtDisclaimers) {
      return (
        <Navigate
          to={`/${language}/admin/${ROUTES.DISCLAIMERS}`}
          replace
          state={state}
        />
      );
    }
    return <AdminLayout />;
  }

  if (requiresPlatformSetup) {
    const isAtControls = pathname.includes(ROUTES.CONTROLS);
    if (!isAtControls) {
      return (
        <Navigate
          to={`/${language}/admin/${ROUTES.CONTROL_BRANDING}`}
          replace
          state={state}
        />
      );
    }
    return <AdminLayout />;
  }

  if (from) {
    return <Navigate to={from} replace />;
  }

  return <AdminLayout />;
};
